
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Completed extends Vue {
    public loading = false;
}
